import React from "react";
import Sprite from "./Sprite";
import { GARLAND, ICONS, SNOW } from "./atlas";
import Twinkles from "./Twinkles";

/*
 * Christmas trim for the edges of things: icicles under the header, a pine
 * garland draped over a card, and a snowbank along the top of the footer.
 * Each is a row of sprites overlapping a few pixels, so the joins between
 * pieces disappear into the snow or the pine.
 */

function repeat(names, count) {
  var out = [];
  for (var i = 0; i < count; i++) out.push(names[(i * 3) % names.length]);
  return out;
}

var ICICLES = repeat(["icicle0", "icicle1", "icicle2", "icicle3", "icicle4"], 60);

/**
 * Snow along the bottom edge of a header bar, with icicles hanging off it.
 * Must sit inside the bar (which is positioned); hangs below it.
 * `compact` is the realtor panel's size, clear of its filter bar's inputs.
 */
export function IcicleEdge({ compact }) {
  return (
    <div className="xm-icicles" aria-hidden="true">
      {ICICLES.map(function (name, index) {
        return <Sprite key={index} atlas={SNOW} name={name} scale={compact ? 0.7 : 1} />;
      })}
    </div>
  );
}

var GARLAND_PIECES = repeat(["garland0", "garland1", "garland2"], 12);

/** Pine garland draped along the top edge of a card. The card must be positioned. */
export function GarlandDrape({ top }) {
  return (
    <div className="xm-garland" aria-hidden="true" style={{ top: top === undefined ? -26 : top }}>
      {GARLAND_PIECES.map(function (name, index) {
        return <Sprite key={index} atlas={GARLAND} name={name} />;
      })}
    </div>
  );
}

var DRIFTS = repeat(["mound0", "drift0", "mound1", "mound2", "drift1", "mound3", "drift2", "mound4"], 40);

/**
 * A snowbank rising out of the top of the footer, with a tree, presents, a
 * snowman and the sleigh standing in it, and stars twinkling over the footer.
 * The footer must be positioned, and leave room above itself (its top margin).
 */
export function SnowBank() {
  return (
    <React.Fragment>
      <div className="xm-drifts" aria-hidden="true">
        <Sprite className="xm-scene" atlas={ICONS} name="tree" scale={0.95} style={{ left: "5%" }} />
        <Sprite className="xm-scene" atlas={ICONS} name="gift" scale={0.5} style={{ left: "calc(5% + 92px)" }} />
        <Sprite className="xm-scene" atlas={ICONS} name="snowman" scale={0.78} style={{ left: "24%" }} />
        <Sprite className="xm-scene" atlas={ICONS} name="sleigh" scale={0.75} style={{ right: "8%" }} />
        <Sprite className="xm-scene" atlas={ICONS} name="ornamentRed" scale={0.4} style={{ right: "calc(8% + 96px)" }} />
        <div className="xm-drift-row">
          {DRIFTS.map(function (name, index) {
            return <Sprite key={index} atlas={SNOW} name={name} />;
          })}
        </div>
      </div>
      <span
        aria-hidden="true"
        style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, overflow: "hidden", pointerEvents: "none" }}
      >
        <Twinkles count={9} seed={2024} area={[8, 85]} />
      </span>
    </React.Fragment>
  );
}
